import React from 'react';
import { AppButton, Box, Inscription, Preloader, RoundPendingIcon } from '@common-fe/common-fe';

import ModalWrapper from '@/components/wrappers/ModalWrapper';

interface Props {
  userFullName: string;
  isDeactivating: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const DeactivateAuthorizedUserModal: React.FC<Props> = ({ userFullName, isDeactivating, onConfirm, onClose }) => (
  <ModalWrapper visible onSetVisible={onClose} testId="authorized-users_deactivate-modal">
    <Box align="center" pad={{ vertical: 'spacing24' }}>
      <RoundPendingIcon color="warning" />
      <Inscription margin={{ top: 'spacing12' }} size="2xl" weight={700} data-testid="authorized-users_deactivate-modal_title">
        Deactivate {userFullName} as an authorized user?
      </Inscription>
      <Box margin={{ top: 'spacing24' }} direction="row" gap="spacing12">
        <AppButton
          buttonType="secondary"
          width="140px"
          testId="authorized-users_deactivate-modal_cancel"
          onClick={onClose}
        >
          Cancel
        </AppButton>
        <AppButton
          color="red"
          width="140px"
          testId="authorized-users_deactivate-modal_confirm"
          onClick={onConfirm}
        >
          {isDeactivating ? (
            <Preloader testId="authorized-users_deactivate-modal_confirm-preloader" color="error" />
          ) : (
            'Yes, Deactivate'
          )}
        </AppButton>
      </Box>
    </Box>
  </ModalWrapper>
);

export default DeactivateAuthorizedUserModal;
